import PropTypes from 'prop-types';

export const StaticContextPropType = PropTypes.shape({
  status: PropTypes.number,
});
